import { apiClient } from '@/services/api';
import { convertToMillisecondTimestamp } from '@/utils/formatDate';
import { logger } from '@/utils/logger/loggerInstance';

export interface SharedRFQToken {
  token: string;
  rfqIds: string[];
  propertyId: string;
  createdBy: string;
  expiresAt: number;
  createdAt: number;
}

export interface SharedRFQPayload {
  rfqs: import('@/models/RequestForQuotation').RequestForQuotation[];
  property: {
    address: string;
    city?: string;
    state?: string;
    zipCode?: string | number;
  };
  issuer: { name?: string; email?: string; phoneNumber?: string } | null;
  expiresAt: number;
}

export const createRFQShareToken = async (params: {
  rfqIds: string[];
  ttlDays?: number;
}): Promise<SharedRFQToken> => {
  const url = '/rfqs/share-token';
  logger.debug(`POST ${url}`);
  const response = await apiClient.post<SharedRFQToken>(url, params);
  return response.data;
};

export const getSharedRFQ = async (token: string): Promise<SharedRFQPayload> => {
  const url = `/rfqs/shared/${encodeURIComponent(token)}`;
  logger.debug(`GET ${url}`);
  const response = await apiClient.get<SharedRFQPayload>(url);
  // Backend returns timestamps in seconds; normalize to ms so date math works.
  return {
    ...response.data,
    rfqs: response.data.rfqs.map((rfq) => ({
      ...rfq,
      createdAt: convertToMillisecondTimestamp(rfq.createdAt),
      updatedAt: convertToMillisecondTimestamp(rfq.updatedAt),
    })),
    expiresAt: convertToMillisecondTimestamp(response.data.expiresAt),
  };
};
